module.exports = __webpack_public_path__ + "static/media/human1.35d9e493.png";